// "use client";

// import React from "react";
// import { Github, Mail } from "lucide-react";

// const Home = () => {
//   const options = [
//     {
//       title: "Letters That Get Noticed.",
//       description: "Craft personalized and impactful letters of recommendation that help your students stand out in the college admissions process. Our AI assists you in capturing their unique story and potential.",
//       cta: "Start Crafting",
//     },
//     {
//       title: "Your Expertise. Amplified by AI.",
//       description: "Move beyond generic templates. Our platform uses AI to help you create truly unique, powerful letters that reflect each student's accomplishments and character, giving them the edge they need.",
//       cta: "Unlock Their Potential",
//     },
//     {
//       title: "Save Time. Make an Impact.",
//       description: "Writing strong letters of recommendation doesn’t have to be time-consuming. Leverage the power of AI to quickly generate tailored drafts so you can focus on what matters most: your students' success.",
//       cta: "Start Creating LORs",
//     },
//   ];

//   // You can select which option to display, for example, the first one.
//   const selectedOption = options[0];

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200 flex flex-col items-center p-4 sm:p-8 font-sans">
//       {/* Hero Section */}
//       <main className="w-full max-w-7xl flex flex-col md:flex-row items-center justify-between py-12 md:py-20 px-4 text-center md:text-left">
//         <div className="md:w-1/2 mb-10 md:mb-0">
//           <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-slate-900 leading-tight mb-4">
//             <span className="bg-clip-text text-transparent bg-gradient-to-r from-teal-500 to-orange-500">
//               {selectedOption.title}
//             </span>{" "}
//             <br />
        
//             <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
            
//             </span>
//           </h1>
//           <p className="text-lg sm:text-xl text-gray-700 mb-8 max-w-md mx-auto md:mx-0">
//             {selectedOption.description}
//           </p>
//           <div className="flex justify-center md:justify-start">
//             <a
//               href="/subscribe"
//               className="px-6 py-3 bg-gradient-to-r from-teal-600 to-orange-600 text-white rounded-full font-semibold shadow-md hover:from-teal-700 hover:to-orange-700 transition"
//             >
//               {selectedOption.cta}
//             </a>
//           </div>
//         </div>
//         <div className="md:w-1/2 flex justify-center items-center">
//           <div className="relative w-full h-64 sm:h-80 md:h-96 rounded-3xl overflow-hidden shadow-lg">
//             <img
//               src="/rec-5.png"
//               alt="AI assisting an educator in writing a professional letter of recommendation"
//               className="object-cover w-full h-full"
//               onError="this.src='https://placehold.co/400x320/9c27b0/ffffff?text=Rec-Builder';"
//             />
//           </div>
//         </div>
//       </main>

//       {/* Call to Action Section */}
//       <section className="w-full max-w-7xl py-12 px-4 text-center">
//         <div className="bg-gradient-to-r from-orange-600 to-red-700 text-white rounded-3xl p-8 sm:p-12 md:p-16 shadow-xl">
//           <h3 className="text-3xl sm:text-4xl font-bold mb-4">
//             Ready to Empower Your Students?
//           </h3>
//           <p className="text-lg mb-8">
//             Streamline your workflow and provide students with the powerful letters of
//             recommendation they deserve.
//           </p>
//           <a
//             href="/subscribe"
//             className="px-8 py-4 bg-white text-orange-700 font-bold rounded-full text-lg shadow-md hover:bg-slate-100 transition transform hover:scale-105"
//           >
//             Start Writing
//           </a>
//         </div>
//       </section>

//       {/* Footer Section */}
//       <footer className="w-full max-w-7xl flex flex-col items-center py-8 px-4 border-t border-gray-200 mt-12">
//         <div className="flex space-x-6 text-gray-500 mb-4">
//           <a href="#" className="hover:text-teal-600 transition" aria-label="GitHub">
//             <Github size={24} />
//           </a>
//           <a href="#" className="hover:text-teal-600 transition" aria-label="Email">
//             <Mail size={24} />
//           </a>
//         </div>
//         <p className="text-gray-500 text-sm">
//           &copy; {new Date().getFullYear()} LoR App. All rights reserved.
//         </p>
//       </footer>
//     </div>
//   );
// };

// export default Home;


"use client";

import React from "react";
import { Github, Mail } from "lucide-react";

const Home = () => {
  const options = [
    {
      title: "Letters That Get Noticed.",
      description:
        "Craft personalized and impactful letters of recommendation that help your students stand out in the college admissions process. Our AI assists you in capturing their unique story and potential.",
      cta: "Start Crafting",
    },
    {
      title: "Your Expertise. Amplified by AI.",
      description:
        "Move beyond generic templates. Our platform uses AI to help you create truly unique, powerful letters that reflect each student's accomplishments and character, giving them the edge they need.",
      cta: "Unlock Their Potential",
    },
    {
      title: "Save Time. Make an Impact.",
      description:
        "Writing strong letters of recommendation doesn’t have to be time-consuming. Leverage the power of AI to quickly generate tailored drafts so you can focus on what matters most: your students' success.",
      cta: "Start Creating LORs",
    },
  ];

  const selectedOption = options[0];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200 flex flex-col items-center font-sans">
      {/* Hero Section */}
      <main className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-12 lg:gap-16">
          {/* Text */}
          <div>
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-slate-900 leading-[1.1] tracking-tight mb-5">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-teal-500 to-orange-500">
                {selectedOption.title}
              </span>
            </h1>

            <p className="text-base sm:text-lg md:text-xl text-gray-700 mb-8 max-w-xl">
              {selectedOption.description}
            </p>

            <div className="flex">
              <a
                href="/subscribe"
                className="inline-flex w-full sm:w-auto justify-center px-6 py-3 bg-gradient-to-r from-teal-600 to-orange-600 text-white rounded-full font-semibold shadow-md hover:from-teal-700 hover:to-orange-700 transition"
              >
                {selectedOption.cta}
              </a>
            </div>
          </div>

          {/* Image */}
          <div className="flex justify-center items-center">
            {/* Aspect ratio container scales on all breakpoints */}
            <div className="relative w-full rounded-3xl overflow-hidden shadow-lg bg-white aspect-[4/3] md:aspect-[16/10]">
              <img
                src="/rec-5.png"
                alt="AI assisting an educator in writing a professional letter of recommendation"
                className="absolute inset-0 w-full h-full object-contain object-center select-none"
                loading="lazy"
                sizes="(min-width: 1024px) 50vw, 100vw"
                onError={(e) => {
                  e.currentTarget.onerror = null; // prevent loops
                  e.currentTarget.src =
                    "https://placehold.co/1200x800/0f172a/ffffff?text=Rec-Builder";
                }}
                draggable={false}
              />
            </div>
          </div>
        </div>
      </main>

      {/* Call to Action Section */}
      <section className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
        <div className="bg-gradient-to-r from-orange-600 to-red-700 text-white rounded-3xl p-6 sm:p-10 md:p-14 lg:p-16 shadow-xl text-center">
          <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4">
            Ready to Empower Your Students?
          </h3>
          <p className="text-base sm:text-lg md:text-xl mb-8 max-w-2xl mx-auto">
            Streamline your workflow and provide students with the powerful letters of
            recommendation they deserve.
          </p>
          <a
            href="/subscribe"
            className="inline-flex w-full sm:w-auto justify-center px-8 py-4 bg-white text-orange-700 font-bold rounded-full text-base sm:text-lg shadow-md hover:bg-slate-100 transition transform hover:scale-[1.03]"
          >
            Start Writing
          </a>
        </div>
      </section>

   
    
    </div>
  );
};

export default Home;
